module.exports = __webpack_public_path__ + "static/media/uoa-21.b6f49c11.jpg";